module.exports = __webpack_public_path__ + "img/special_events.eed681d3.jpg";